module.exports = __webpack_public_path__ + "static/media/bee.a5265611.png";